import SearchTableRoles from "./components/SearchTableRoles";
import Card from "components/card";
import { useUserInfo } from "layouts/user-info/_context/UserinfoContext";

const RolesDataTable = () => {
  const { roles } = useUserInfo();
  return (
    <Card extra={"w-full h-full mt-3"}>
      <SearchTableRoles tableData={roles} />
    </Card>
  );
};

export default RolesDataTable;
